// src/services/notificationSoundService.js

// Cache pour les sons préchargés
const soundCache = {};

// Précharger les sons pour un déclenchement plus rapide
const preloadSounds = () => {
  const soundFiles = {
    default: '/sounds/notification.mp3',
    message: '/sounds/message.mp3',     // Optionnel: différents sons pour différents types
    alert: '/sounds/alert.mp3',         // Optionnel: différents sons pour différents types
  };

  Object.entries(soundFiles).forEach(([key, path]) => {
    const audio = new Audio(path);
    // Précharger l'audio
    audio.load();
    soundCache[key] = audio;
  });
};

// Jouer un son de notification
const playNotificationSound = (type = 'default') => {
  // Vérifier si les sons sont activés
  if (!areSoundsEnabled()) {
    return;
  }
  
  // Vérifier si le son est préchargé
  if (soundCache[type]) {
    // Réinitialiser l'audio pour permettre plusieurs lectures consécutives
    soundCache[type].currentTime = 0;
    
    // Jouer le son avec une promesse pour gérer les erreurs
    const playPromise = soundCache[type].play();
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.error("Erreur lors de la lecture du son de notification:", error);
        // Essayer une deuxième fois après l'interaction utilisateur
        document.addEventListener('click', () => {
          soundCache[type].play().catch(err => console.error("Échec de la lecture du son:", err));
        }, { once: true });
      });
    }
  } else {
    console.warn(`Son de notification de type "${type}" non trouvé.`);
  }
};

// Vérifier si les sons sont activés dans les préférences de l'utilisateur
const areSoundsEnabled = () => {
  return localStorage.getItem('notificationSoundsEnabled') !== 'false';
};

// Activer/désactiver les sons
const toggleNotificationSounds = (enabled) => {
  localStorage.setItem('notificationSoundsEnabled', enabled.toString());
  return enabled;
};

// Initialiser le service au démarrage
const initSoundService = () => {
  preloadSounds();
  
  // Vérifier si le localStorage existe déjà, sinon initialiser
  if (localStorage.getItem('notificationSoundsEnabled') === null) {
    localStorage.setItem('notificationSoundsEnabled', 'true');
  }
};

// Créer un objet de service nommé
const notificationSoundService = {
  initSoundService,
  playNotificationSound,
  areSoundsEnabled,
  toggleNotificationSounds
};

// Exporter l'objet nommé
export default notificationSoundService;